"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var core_1 = require("@vueuse/core");
var mask_vue_1 = require("../../../components/mask/mask.vue");
var index_vue_1 = require("../../../components/transfer/index.vue");
var index_vue_2 = require("../../../components/slider/index.vue");
var manage_name_vue_1 = require("./manage-name.vue");
var manage_notification_vue_1 = require("./manage-notification.vue");
var manage_member_vue_1 = require("./manage-member.vue");
var member_profile_vue_1 = require("./member-profile.vue");
var index_vue_3 = require("../../../components/dialog/index.vue");
var vuex_1 = require("vuex");
var TUIAegis_1 = require("../../../../utils/TUIAegis");
var utils_1 = require("../../utils");
var vue_clipboard3_1 = require("vue-clipboard3");
var manage = vue_1.defineComponent({
    components: {
        Mask: mask_vue_1.default,
        Transfer: index_vue_1.default,
        Slider: index_vue_2.default,
        ManageName: manage_name_vue_1.default,
        ManageNotification: manage_notification_vue_1.default,
        ManageMember: manage_member_vue_1.default,
        MemeberProfile: member_profile_vue_1.default,
        Dialog: index_vue_3.default,
    },
    props: {
        userInfo: {
            type: Object,
            default: function () { return ({
                isGroup: false,
                list: [],
            }); },
        },
        conversation: {
            type: Object,
            default: function () { return ({}); },
        },
        show: {
            type: Boolean,
            default: function () { return false; },
        },
        isH5: {
            type: Boolean,
            default: function () { return false; },
        },
    },
    setup: function (props, ctx) {
        var _a;
        var _this = this;
        var _b, _c, _d;
        var types = manage.TUIServer.TUICore.TIM.TYPES;
        var GroupServer = manage.GroupServer;
        var t = manage.TUIServer.TUICore.config.i18n.useI18n().t;
        var data = vue_1.reactive({
            conversation: {},
            userInfo: {
                isGroup: false,
                list: [],
            },
            isShowMuteTimeInput: false,
            editLableName: "",
            mask: false,
            currentTab: "",
            transferType: "",
            isSearch: false,
            isRadio: false,
            transferList: [],
            selectedList: [],
            isMuteTime: false,
            show: false,
            typeName: (_a = {},
                _a[types.GRP_WORK] = "好友工作群",
                _a[types.GRP_PUBLIC] = "陌生人社交群",
                _a[types.GRP_MEETING] = "临时会议群",
                _a[types.GRP_AVCHATROOM] = "直播群",
                _a[types.JOIN_OPTIONS_FREE_ACCESS] = "自由加入",
                _a[types.JOIN_OPTIONS_NEED_PERMISSION] = "需要验证",
                _a[types.JOIN_OPTIONS_DISABLE_APPLY] = "禁止加群",
                _a),
            delDialogShow: false,
            userList: [],
            transferTitle: "",
            member: {
                admin: [],
                member: [],
                muteMember: [],
            },
            currentMember: {},
        });
        var dialog = vue_1.ref();
        vue_1.watchEffect(function () {
            data.conversation = props.conversation;
            data.userInfo = props.userInfo;
            data.show = props.show;
        });
        var VuexStore = (((_c = (_b = window) === null || _b === void 0 ? void 0 : _b.TUIKitTUICore) === null || _c === void 0 ? void 0 : _c.isOfficial) && ((_d = vuex_1.default) === null || _d === void 0 ? void 0 : _d.useStore())) || {};
        var TabName = vue_1.computed(function () {
            var name = "";
            switch (data.currentTab) {
                case "notification":
                    name = "群公告";
                    break;
                case "member":
                    name = "群成员";
                    break;
                case "profile":
                    name = "群成员";
                    break;
                default:
                    name = "群管理";
                    break;
            }
            return name;
        });
        vue_1.watch(function () { return data.userInfo.list; }, function (newValue, oldValue) {
            data.member = {
                admin: [],
                member: [],
                muteMember: [],
            };
            newValue.map(function (item) {
                switch (item === null || item === void 0 ? void 0 : item.role) {
                    case types.GRP_MBR_ROLE_ADMIN:
                        data.member.admin.push(item);
                        break;
                    case types.GRP_MBR_ROLE_MEMBER:
                        data.member.member.push(item);
                        break;
                    default:
                        break;
                }
                return item;
            });
            var time = new Date().getTime();
            data.member.muteMember = newValue.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.muteUntil) * 1000 - time > 0; });
        }, { deep: true });
        var isDismissGroupAuth = vue_1.computed(function () {
            var _a, _b;
            var conversation = data.conversation;
            var userRole = (_a = conversation === null || conversation === void 0 ? void 0 : conversation.groupProfile) === null || _a === void 0 ? void 0 : _a.selfInfo.role;
            var groupType = (_b = conversation === null || conversation === void 0 ? void 0 : conversation.groupProfile) === null || _b === void 0 ? void 0 : _b.type;
            var isOwner = userRole === types.GRP_MBR_ROLE_OWNER;
            var isWork = groupType === types.GRP_WORK;
            return isOwner && !isWork;
        });
        var isShowAddMember = vue_1.computed(function () {
            var _a;
            var conversation = data.conversation;
            var groupType = (_a = conversation === null || conversation === void 0 ? void 0 : conversation.groupProfile) === null || _a === void 0 ? void 0 : _a.type;
            var isWork = groupType === types.GRP_WORK;
            if (isWork) {
                return true;
            }
            return false;
        });
        var showUserNum = vue_1.computed(function () {
            var num = 3;
            if (!isShowAddMember.value) {
                num += 1;
            }
            if (data.conversation.groupProfile.selfInfo.role !== "Owner") {
                num += 1;
            }
            return num;
        });
        var isAuth = vue_1.computed(function () {
            var _a;
            var conversation = data.conversation;
            var userRole = (_a = conversation === null || conversation === void 0 ? void 0 : conversation.groupProfile) === null || _a === void 0 ? void 0 : _a.selfInfo.role;
            var isOwner = userRole === types.GRP_MBR_ROLE_OWNER;
            var isAdmin = userRole === types.GRP_MBR_ROLE_ADMIN;
            return isOwner || isAdmin;
        });
        var isAdmin = vue_1.computed(function () {
            var _a, _b;
            var conversation = data.conversation;
            var groupType = (_a = conversation === null || conversation === void 0 ? void 0 : conversation.groupProfile) === null || _a === void 0 ? void 0 : _a.type;
            var userRole = (_b = conversation === null || conversation === void 0 ? void 0 : conversation.groupProfile) === null || _b === void 0 ? void 0 : _b.selfInfo.role;
            var isOwner = userRole === types.GRP_MBR_ROLE_OWNER;
            var isWork = groupType === types.GRP_WORK;
            var isAVChatRoom = groupType === types.GRP_AVCHATROOM;
            if (!isWork && !isAVChatRoom && isOwner) {
                return true;
            }
            return false;
        });
        var isSetMuteTime = vue_1.computed(function () {
            var _a;
            var conversation = data.conversation;
            var groupType = (_a = conversation === null || conversation === void 0 ? void 0 : conversation.groupProfile) === null || _a === void 0 ? void 0 : _a.type;
            var isWork = groupType === types.GRP_WORK;
            if (isWork || !isAuth.value) {
                return false;
            }
            return true;
        });
        var getMember = function (type) {
            var _a;
            var conversation = data.conversation;
            var options = {
                groupID: (_a = conversation === null || conversation === void 0 ? void 0 : conversation.groupProfile) === null || _a === void 0 ? void 0 : _a.groupID,
                count: 100,
                offset: type && type === "more" ? data.userInfo.list.length : 0,
            };
            GroupServer.getGroupMemberList(options).then(function (res) {
                if (type && type === "more") {
                    data.userInfo.list = __spreadArrays(data.userInfo.list, res.data.memberList);
                }
                else {
                    data.userInfo.list = res.data.memberList;
                }
            });
        };
        var addMember = function (userIDList) { return __awaiter(_this, void 0, void 0, function () {
            var conversation, options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        conversation = data.conversation;
                        options = {
                            groupID: conversation.groupProfile.groupID,
                            userIDList: userIDList,
                        };
                        return [4 /*yield*/, GroupServer.addGroupMember(options)];
                    case 1:
                        _a.sent();
                        getMember("More");
                        return [2 /*return*/];
                }
            });
        }); };
        var deleteMember = function (user) {
            var conversation = data.conversation;
            var options = {
                groupID: conversation.groupProfile.groupID,
                userIDList: [user.userID],
            };
            GroupServer.deleteGroupMember(options);
        };
        var changeOwner = function (userID) { return __awaiter(_this, void 0, void 0, function () {
            var options, imResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {
                            groupID: data.conversation.groupProfile.groupID,
                            newOwnerID: userID,
                        };
                        return [4 /*yield*/, GroupServer.changeGroupOwner(options)];
                    case 1:
                        imResponse = _a.sent();
                        data.conversation.groupProfile = {};
                        data.conversation.groupProfile = imResponse.data.group;
                        return [2 /*return*/];
                }
            });
        }); };
        var quit = function (group) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, GroupServer.quitGroup(group.groupID)];
                    case 1:
                        _a.sent();
                        manage.TUIServer.store.conversation = {};
                        return [2 /*return*/];
                }
            });
        }); };
        var dismiss = function (group) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, GroupServer.dismissGroup(group.groupID)];
                    case 1:
                        _c.sent();
                        manage.TUIServer.store.conversation = {};
                        ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.TUIKitTUICore) === null || _b === void 0 ? void 0 : _b.isOfficial) && (VuexStore === null || VuexStore === void 0 ? void 0 : VuexStore.commit) && (VuexStore === null || VuexStore === void 0 ? void 0 : VuexStore.commit("handleTask", 5));
                        return [2 /*return*/];
                }
            });
        }); };
        var handleAdmin = function (user) { return __awaiter(_this, void 0, void 0, function () {
            var conversation, role, options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        conversation = data.conversation;
                        role = "";
                        switch (user.role) {
                            case types.GRP_MBR_ROLE_ADMIN:
                                role = types.GRP_MBR_ROLE_MEMBER;
                                break;
                            case types.GRP_MBR_ROLE_MEMBER:
                                role = types.GRP_MBR_ROLE_ADMIN;
                                break;
                        }
                        options = {
                            groupID: conversation.groupProfile.groupID,
                            userID: user.userID,
                            role: role,
                        };
                        return [4 /*yield*/, GroupServer.setGroupMemberRole(options)];
                    case 1:
                        _a.sent();
                        getMember();
                        return [2 /*return*/];
                }
            });
        }); };
        var setMemberMuteTime = function (userID, type) { return __awaiter(_this, void 0, void 0, function () {
            var conversation, options;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        conversation = data.conversation;
                        options = {
                            groupID: conversation.groupProfile.groupID,
                            userID: userID,
                            muteTime: type === "add" ? 60 * 60 * 24 * 30 : 0,
                        };
                        return [4 /*yield*/, GroupServer.setGroupMemberMuteTime(options)];
                    case 1:
                        _c.sent();
                        if (type === "add") {
                            ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.TUIKitTUICore) === null || _b === void 0 ? void 0 : _b.isOfficial) && (VuexStore === null || VuexStore === void 0 ? void 0 : VuexStore.commit) && (VuexStore === null || VuexStore === void 0 ? void 0 : VuexStore.commit("handleTask", 4));
                        }
                        getMember();
                        return [2 /*return*/];
                }
            });
        }); };
        var kickedOut = function (userIDList) { return __awaiter(_this, void 0, void 0, function () {
            var conversation, options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        conversation = data.conversation;
                        options = {
                            groupID: conversation.groupProfile.groupID,
                            userIDList: userIDList,
                            reason: "",
                        };
                        return [4 /*yield*/, GroupServer.deleteGroupMember(options)];
                    case 1:
                        _a.sent();
                        getMember();
                        return [2 /*return*/];
                }
            });
        }); };
        var edit = function (labelName) {
            data.editLableName = labelName;
        };
        var updateProfile = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var key, value, options, res, conversation;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        key = params.key, value = params.value;
                        options = (_a = {
                                groupID: data.conversation.groupProfile.groupID
                            },
                            _a[key] = value,
                            _a);
                        return [4 /*yield*/, GroupServer.updateGroupProfile(options)];
                    case 1:
                        res = _b.sent();
                        conversation = manage.TUIServer.store.conversation;
                        conversation.groupProfile = res.data.group;
                        manage.TUIServer.store.conversation = {};
                        manage.TUIServer.store.conversation = conversation;
                        data.editLableName = "";
                        return [2 /*return*/];
                }
            });
        }); };
        var setTab = function (tabName) {
            data.currentTab = tabName;
            data.editLableName = "";
            if (data.currentTab === "member") {
                data.transferType = "remove";
            }
            if (!data.currentTab) {
                data.transferType = "";
            }
        };
        var handleSearchMember = function (value) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, imMemberResponse, options, _a, error_1, message, message, error_2, message;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        imResponse = {};
                        imMemberResponse = {};
                        options = {
                            groupID: data.conversation.groupProfile.groupID,
                            userIDList: [value],
                        };
                        _a = data.transferType;
                        switch (_a) {
                            case "add": return [3 /*break*/, 1];
                            case "remove": return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 9];
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, GroupServer.getGroupMemberProfile(options)];
                    case 2:
                        imMemberResponse = _d.sent();
                        data.transferList = data.transferList.filter(function (item) { var _a; return item.userID !== ((_a = imResponse.data[0]) === null || _a === void 0 ? void 0 : _a.userID); });
                        data.transferList = __spreadArrays(data.transferList, imResponse.data);
                        if (((_b = imMemberResponse === null || imMemberResponse === void 0 ? void 0 : imMemberResponse.data) === null || _b === void 0 ? void 0 : _b.memberList.length) > 0) {
                            data.transferList = data.transferList.map(function (item) {
                                var _a;
                                if (item.userID === ((_a = imMemberResponse === null || imMemberResponse === void 0 ? void 0 : imMemberResponse.data) === null || _a === void 0 ? void 0 : _a.memberList[0].userID)) {
                                    item.isDisabled = true;
                                }
                                return item;
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _d.sent();
                        message = t("TUIChat.manage.该用户不存在");
                        utils_1.handleErrorPrompts(message, props);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 10];
                    case 5:
                        _d.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, GroupServer.getGroupMemberProfile(options)];
                    case 6:
                        imResponse = _d.sent();
                        if (imResponse.data.memberList.length === 0) {
                            message = t("TUIChat.manage.该用户不在群组内");
                            return [2 /*return*/, utils_1.handleErrorPrompts(message, props)];
                        }
                        data.transferList = data.transferList.filter(function (item) { var _a, _b; return item.userID !== ((_b = (_a = imResponse === null || imResponse === void 0 ? void 0 : imResponse.data) === null || _a === void 0 ? void 0 : _a.memberList[0]) === null || _b === void 0 ? void 0 : _b.userID); });
                        data.transferList = __spreadArrays(data.transferList, (_c = imResponse === null || imResponse === void 0 ? void 0 : imResponse.data) === null || _c === void 0 ? void 0 : _c.memberList);
                        return [3 /*break*/, 8];
                    case 7:
                        error_2 = _d.sent();
                        message = t("TUIChat.manage.该用户不存在");
                        utils_1.handleErrorPrompts(message, props);
                        return [3 /*break*/, 8];
                    case 8: return [3 /*break*/, 10];
                    case 9: return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        }); };
        var submit = function (userList) {
            if (data.transferType === "remove") {
                data.userList = userList;
                data.delDialogShow = !data.delDialogShow;
            }
            else {
                handleManage(userList, data.transferType);
            }
            data.mask = false;
        };
        var friendList = function () { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, friendList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, manage.TUIServer.getFriendList()];
                    case 1:
                        imResponse = _a.sent();
                        friendList = imResponse.data.map(function (item) { return item === null || item === void 0 ? void 0 : item.profile; });
                        return [2 /*return*/, friendList.filter(function (item) { return !data.userInfo.list.some(function (infoItem) { return infoItem.userID === item.userID; }); })];
                }
            });
        }); };
        var cancel = function () {
            toggleMask();
        };
        var toggleMask = function (type) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        data.selectedList = [];
                        _a = type;
                        switch (_a) {
                            case "add": return [3 /*break*/, 1];
                            case "remove": return [3 /*break*/, 3];
                            case "addAdmin": return [3 /*break*/, 4];
                            case "removeAdmin": return [3 /*break*/, 5];
                            case "changeOwner": return [3 /*break*/, 6];
                            case "addMute": return [3 /*break*/, 7];
                            case "removeMute": return [3 /*break*/, 8];
                        }
                        return [3 /*break*/, 9];
                    case 1:
                        data.isRadio = false;
                        _b = data;
                        return [4 /*yield*/, friendList()];
                    case 2:
                        _b.transferList = _c.sent();
                        data.transferTitle = "添加成员";
                        return [3 /*break*/, 10];
                    case 3:
                        data.isRadio = false;
                        data.transferList = data.userInfo.list.filter(function (item) { var _a, _b; return item.userID !== ((_b = (_a = data.conversation) === null || _a === void 0 ? void 0 : _a.groupProfile) === null || _b === void 0 ? void 0 : _b.selfInfo.userID); });
                        data.transferTitle = "删除成员";
                        return [3 /*break*/, 10];
                    case 4:
                        data.isRadio = true;
                        data.transferList = data.member.member;
                        data.transferTitle = "新增管理员";
                        return [3 /*break*/, 10];
                    case 5:
                        data.isRadio = true;
                        data.transferList = data.member.admin;
                        data.transferTitle = "移除管理员";
                        return [3 /*break*/, 10];
                    case 6:
                        data.isRadio = true;
                        data.transferList = __spreadArrays(data.member.admin, data.member.member);
                        data.transferTitle = "转让群组";
                        return [3 /*break*/, 10];
                    case 7:
                        data.isRadio = true;
                        data.transferList = data.member.member;
                        if (data.conversation.groupProfile.selfInfo.role === "Owner") {
                            data.transferList = __spreadArrays(data.member.admin, data.member.member);
                        }
                        data.transferTitle = "新增禁言用户";
                        return [3 /*break*/, 10];
                    case 8:
                        data.isRadio = true;
                        data.transferList = data.member.muteMember;
                        data.transferTitle = "移除禁言用户";
                        return [3 /*break*/, 10];
                    case 9: return [3 /*break*/, 10];
                    case 10:
                        data.transferType = type;
                        data.mask = !data.mask;
                        return [2 /*return*/];
                }
            });
        }); };
        core_1.onClickOutside(dialog, function () {
            data.show = false;
        });
        var toggleShow = function () {
            if (!GroupServer) {
                var message = t("TUIChat.manage.请先注册 TUIGroup 模块");
                return utils_1.handleErrorPrompts(message, props);
            }
            data.show = !data.show;
            if (!data.show) {
                data.currentTab = "";
            }
            if (data.show) {
                getMember();
                TUIAegis_1.default.getInstance().reportEvent({
                    name: "showGroupManage",
                    ext1: "showGroupManage",
                });
            }
        };
        var setAllMuteTime = function (value) {
            var _a, _b;
            updateProfile({ key: "muteAllMembers", value: value });
            ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.TUIKitTUICore) === null || _b === void 0 ? void 0 : _b.isOfficial) && (VuexStore === null || VuexStore === void 0 ? void 0 : VuexStore.commit) && (VuexStore === null || VuexStore === void 0 ? void 0 : VuexStore.commit("handleTask", 4));
        };
        var handleManage = function (userList, type) {
            var userIDList = [];
            userList.map(function (item) {
                userIDList.push(item.userID);
                return item;
            });
            TUIAegis_1.default.getInstance().reportEvent({
                name: "groupOptions",
                ext1: "groupOptions",
            });
            switch (type) {
                case "add":
                    addMember(userIDList);
                    TUIAegis_1.default.getInstance().reportEvent({
                        name: "groupOptions",
                        ext1: "groupAddMember",
                    });
                    break;
                case "remove":
                    kickedOut(userIDList);
                    TUIAegis_1.default.getInstance().reportEvent({
                        name: "groupOptions",
                        ext1: "groupRemoveMember",
                    });
                    break;
                case "addAdmin":
                    handleAdmin(userList[0]);
                    TUIAegis_1.default.getInstance().reportEvent({
                        name: "groupOptions",
                        ext1: "groupAddAdmin",
                    });
                    break;
                case "removeAdmin":
                    handleAdmin(userList[0]);
                    TUIAegis_1.default.getInstance().reportEvent({
                        name: "groupOptions",
                        ext1: "groupRemoveAdmin",
                    });
                    break;
                case "changeOwner":
                    changeOwner(userIDList[0]);
                    TUIAegis_1.default.getInstance().reportEvent({
                        name: "groupOptions",
                        ext1: "groupChangeOwner",
                    });
                    break;
                case "addMute":
                    setMemberMuteTime(userIDList[0], "add");
                    TUIAegis_1.default.getInstance().reportEvent({
                        name: "groupOptions",
                        ext1: "groupAddMute",
                    });
                    break;
                case "removeMute":
                    setMemberMuteTime(userIDList[0], "remove");
                    TUIAegis_1.default.getInstance().reportEvent({
                        name: "groupOptions",
                        ext1: "groupRemoveMute",
                    });
                    break;
                default:
                    break;
            }
        };
        var handleGroupIDCopy = function () { return __awaiter(_this, void 0, void 0, function () {
            var toClipboard, error_3;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        toClipboard = vue_clipboard3_1.default().toClipboard;
                        return [4 /*yield*/, toClipboard((_b = (_a = data === null || data === void 0 ? void 0 : data.conversation) === null || _a === void 0 ? void 0 : _a.groupProfile) === null || _b === void 0 ? void 0 : _b.groupID)];
                    case 1:
                        _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _c.sent();
                        utils_1.handleErrorPrompts(error_3, data.env);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var handleMemberProfileShow = function (user) {
            data.currentMember = user;
            setTab("profile");
        };
        return __assign(__assign({}, vue_1.toRefs(data)), { isDismissGroupAuth: isDismissGroupAuth,
            isShowAddMember: isShowAddMember,
            isSetMuteTime: isSetMuteTime,
            isAdmin: isAdmin,
            isAuth: isAuth,
            addMember: addMember,
            deleteMember: deleteMember,
            changeOwner: changeOwner,
            quit: quit,
            dismiss: dismiss,
            handleAdmin: handleAdmin,
            setMemberMuteTime: setMemberMuteTime,
            kickedOut: kickedOut,
            edit: edit,
            updateProfile: updateProfile,
            setTab: setTab,
            TabName: TabName,
            getMember: getMember,
            handleSearchMember: handleSearchMember,
            submit: submit,
            cancel: cancel,
            toggleMask: toggleMask,
            toggleShow: toggleShow,
            setAllMuteTime: setAllMuteTime,
            handleManage: handleManage,
            showUserNum: showUserNum,
            dialog: dialog,
            handleGroupIDCopy: handleGroupIDCopy,
            handleMemberProfileShow: handleMemberProfileShow });
    },
});
exports.default = manage;
